import {Pipe, PipeTransform} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';
import {SafeHtmlService} from '@orga-app/providers/safe-html.service';

@Pipe({
    name: 'safeHtml'
})
export class SafeHtmlPipe implements PipeTransform {

    constructor(private sanitizer: DomSanitizer, private safeHtmlService: SafeHtmlService) {
    }

    transform(value: any, args?: any): any {
        // remove XSS elements
        value = this.safeHtmlService.sanitize(value);

        return this.sanitizer.bypassSecurityTrustHtml(value);
    }

}
